import { useEffect } from "react";
import { useRef } from "react";
import styles from "./fullpagePinLayout.module.css";
import gsap from "gsap";
import ScrollTrigger from "gsap/src/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const FullpagePinLayout = ({
  className = '',
  children,
  pin = true,
  animation = true,
}) => {
  const ctnRef = useRef(null);
//   useEffect(() => {
//     let tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: ctnRef.current,
//         pin: true,
//         start: "top top",
//         pin: pin,
//       },
//     });

//     if (animation) {
//       tl.to(ctnRef.current.querySelector("div"), {
//         y: 0,
//         opacity: 1,
//       });
//     }
//   }, []);
  return (
    <div className={`${styles.ctn} ${className}`} ref={ctnRef}>
      {children}
    </div>
  );
};

export default FullpagePinLayout;
